import _slicedToArray from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
try {
  if (process.env.TOKENS_FEATURE_FLAG === 'true' || process.env.STORYBOOK_TOKENS_FEATURE_FLAG !== 'false') require('./index-new.css');else require('./index.css');
} catch (e) {
  if (e.code !== 'MODULE_NOT_FOUND') {
    throw e; // Re-throw unexpected errors
  }

  console.warn('index.css / index-new.css not found, proceeding without it.');
}
import { jsx, jsxs } from 'react/jsx-runtime';
import { RTEText } from '@design-system/rte-text';
import { Tooltip } from '@design-system/tooltip';
import { Typography } from '@design-system/typography';
import classNames from 'classnames';
import { forwardRef, useState, useEffect, useCallback } from 'react';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
function __rest(s, e) {
  var t = {};
  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}
var CheckboxField = forwardRef(function (_a, ref) {
  var className = _a.className,
    id = _a.id,
    label = _a.label,
    description = _a.description,
    tooltipLabel = _a.tooltipLabel,
    tooltipText = _a.tooltipText,
    name = _a.name,
    defaultChecked = _a.defaultChecked,
    errorMessage = _a.errorMessage,
    onChange = _a.onChange,
    onBlur = _a.onBlur,
    isDisabled = _a.isDisabled,
    isError = _a.isError,
    _a$variant = _a.variant,
    variant = _a$variant === void 0 ? 'outline' : _a$variant,
    isHidden = _a.isHidden,
    checked = _a.checked,
    hideCheckbox = _a.hideCheckbox,
    rest = __rest(_a, ["className", "id", "label", "description", "tooltipLabel", "tooltipText", "name", "defaultChecked", "errorMessage", "onChange", "onBlur", "isDisabled", "isError", "variant", "isHidden", "checked", "hideCheckbox"]);
  var _useState = useState(checked),
    _useState2 = _slicedToArray(_useState, 2),
    checkedState = _useState2[0],
    setCheckedState = _useState2[1];
  useEffect(function () {
    setCheckedState(checked);
  }, [checked]);
  var onKeyDown = useCallback(function (e) {
    if (e.key === 'Enter' && onChange) {
      onChange(e);
      setCheckedState(e.target.checked);
    }
  }, [onChange]);
  var handleOnChange = useCallback(function (e) {
    if (onChange) {
      onChange(e);
      setCheckedState(e.target.checked);
    }
  }, [onChange]);
  var renderCheckbox = function renderCheckbox() {
    return !hideCheckbox && jsx("input", Object.assign({
      className: classNames('cds-checkbox-field__input', {
        'cds-checkbox-field__input--error': isError,
        'cds-checkbox-field__input--disabled': isDisabled
      }),
      "aria-invalid": Boolean(errorMessage),
      id: id,
      type: "checkbox",
      name: name,
      onChange: handleOnChange,
      onKeyDown: onKeyDown,
      defaultChecked: defaultChecked,
      checked: checkedState,
      onBlur: onBlur,
      ref: ref,
      disabled: isDisabled
    }, rest));
  };
  return jsx("div", Object.assign({
    className: classNames('cds-checkbox-field', className, {
      'cds-checkbox-field--hidden': isHidden
    })
  }, {
    children: jsx("header", Object.assign({
      className: "cds-checkbox-field__header"
    }, {
      children: jsxs("label", Object.assign({
        className: classNames('cds-checkbox-field__label', {
          'cds-checkbox-field__label--error': isError,
          'cds-checkbox-field__label--disabled': isDisabled,
          'cds-checkbox-field__label--filled': variant === 'filled'
        }),
        htmlFor: id
      }, {
        children: [description ? jsxs("div", Object.assign({
          className: "cds-checkbox-field__description-wrapper"
        }, {
          children: [renderCheckbox(), jsx(RTEText, {
            text: description,
            className: "cds-checkbox-field__rte"
          })]
        })) : jsxs("div", Object.assign({
          className: "cds-checkbox-field__title-wrapper"
        }, {
          children: [renderCheckbox(), label && jsx(Typography, {
            tag: "span",
            variant: "body",
            className: "cds-checkbox-field__title",
            size: "m",
            content: label
          })]
        })), tooltipLabel && tooltipText && jsx(Tooltip, {
          label: tooltipLabel,
          text: tooltipText
        })]
      }))
    }))
  }));
});
export { CheckboxField };